import React from 'react';
//import { useNavigate } from "react-router-dom";


import {
  formatError,
  login,
  googlelogin,
  runLogoutTimer,
  saveTokenInLocalStorage,
  saveUserDataLocalStorage,
  signUp,
  microsoftlogin
  ,
} from '../../services/AuthService';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { msalConfig } from '../../msalconfig';
import { BrowserAuthError, PublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from '../../msalconfig';
import { getResolvedLandingPage } from '../../utils/userSettings';
export const msalInstance = new PublicClientApplication(msalConfig);

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const ADD_REGISTRATIONDETAILS = 'addRegistrationDetails';




export function signupAction(email, password, navigate) {

  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        dispatch(confirmedSignupAction({
          token: response.data.accessToken,
          user: response.data.user
        }));
        navigate('/task/tasklist');
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  // Clear subscription caches
  try {
    const { clearDocumentSubscriptionCache } = require('../../utils/documentAccess');
    const { clearSubscriptionCache } = require('../../utils/featureLock');
    clearDocumentSubscriptionCache();
    clearSubscriptionCache();
  } catch (err) {
    console.error('Error clearing subscription caches:', err);
  }

  // Clear all authentication data
  localStorage.removeItem('userDetails');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('tempAccessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('rememberMe');
  localStorage.removeItem('userPlanFeatures'); // Clear user plan features
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('tabCount');
  sessionStorage.removeItem('isFirstSession');
  sessionStorage.removeItem('redirectAfterLogin'); // Clear stored redirect page

  // Set a 'logout' flag in localStorage to trigger logout in all tabs
  localStorage.setItem('logout', Date.now());

  // Dispatch logout action to clear Redux state
  const logoutAction = {
    type: LOGOUT_ACTION,
  };

  // Navigate to login page
  navigate('/login');

  return logoutAction;
}
const notifyTopRight = (data) => {
  toast.success(`✔️ ${data}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });
};
const notifyError = (data) => {

  toast.error(`❌ ${data}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
export function loginAction(email, password, navigate, rememberMe, multiCorporateCallback) {
  return (dispatch) => {
    <ToastContainer />
    login(email, password)
      .then((response) => {
        console.log(response)
        // Multi-corporate flow handling
        if (response.data && response.data.corporates && response.data.verificationToken) {
          if (typeof multiCorporateCallback === 'function') {
            multiCorporateCallback({
              corporates: response.data.corporates,
              verificationToken: response.data.verificationToken,
              email: email
            });
          }

          dispatch(loadingToggleAction(false));
          return;
        }
        try {
          const expiresIn = response.data.expiresIn ? response.data.expiresIn * 1000 : 3600000;
          // Pass API timestamp if available (assuming it's in response.data.timestamp or similar field)
          const apiTimestamp = response.data.timestamp || response.data.issuedAt || response.data.createdAt;
          saveTokenInLocalStorage(response.data.accessToken, rememberMe, apiTimestamp);
          saveUserDataLocalStorage(response.data.user);

          dispatch(loginConfirmedAction({
            token: response.data.accessToken,
            user: response.data.user
          }));

          // Dispatch event to notify components of user login
          try {
            window.dispatchEvent(new Event('user-logged-in'));
          } catch (e) {
            console.error('Error dispatching user-logged-in event:', e);
          }

          // Redirect logic
          const redirectPath = sessionStorage.getItem('redirectAfterLogin');
          if (redirectPath) {
            const userData = localStorage.getItem('user');
            const parsedUser = userData ? JSON.parse(userData) : null;
            const isCorporate = parsedUser?.type === 'corporate' || false;
            if (redirectPath.includes('user-subscription') && !isCorporate) {
              navigate('/task/tasklist', { replace: true });
            } else {
              navigate(redirectPath, { replace: true });
            }
            sessionStorage.removeItem('redirectAfterLogin');
          } else {
            getResolvedLandingPage().then((path) => {
              navigate(path, { replace: true });
            });
          }
        } catch (err) {
          console.error('Error inside .then():', err);
          notifyError('Something went wrong while processing login.');
          notifyError('Error inside .then():', err);
        }
      })
      .catch((error) => {
        console.error('Login failed at network or catch block:', error);

        let errorMessage;
        if (error?.response?.status === 401) {
          errorMessage = 'Invalid user name or password';
        } else {
          errorMessage = error?.response?.data?.message || error?.message || 'Something went wrong.';
        }

        notifyError(errorMessage);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}
export function googleloginAction(token, navigate, rememberMe = false) {
  return (dispatch) => {
    <ToastContainer />
    googlelogin(token).then((response) => {
      try {
        const expiresIn = response.data.expiresIn ? response.data.expiresIn * 1000 : 3600000;
        // Pass API timestamp if available
        const apiTimestamp = response.data.timestamp || response.data.issuedAt || response.data.createdAt;
        saveTokenInLocalStorage(response.data.token, rememberMe, apiTimestamp);
        saveUserDataLocalStorage(response.data.user);

        dispatch(loginConfirmedAction({
          token: response.data.token,
          user: response.data.user
        }));

        // Dispatch event to notify components of user login
        try {
          window.dispatchEvent(new Event('user-logged-in'));
        } catch (e) {
          console.error('Error dispatching user-logged-in event:', e);
        }

        console.log('Navigating to dashboard...');
        if (response.message == 'Request failed with status code 401') {
          notifyError(response.data)
        }
        // Redirect logic
        const redirectPath = sessionStorage.getItem('redirectAfterLogin');
        if (redirectPath) {
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectPath, { replace: true });
        } else {
          getResolvedLandingPage().then((path) => {
            navigate(path, { replace: true });
          });
        }
      } catch (err) {
        notifyError('Error inside .then():', err);
      }
    })
      .catch((error) => {
        console.error('Login failed at network or catch block:', error);
        const errorMessage = formatError(error?.response?.data?.message || 'Something went wrong.');
        dispatch(loginFailedAction(errorMessage));
      });
  };
}
export function microsoftloginAction(idToken, navigate, rememberMe = false) {
  return async (dispatch) => {
    try {
      const response = await microsoftlogin(idToken);
      try {
        const expiresIn = response.data.expiresIn ? response.data.expiresIn * 1000 : 3600000;
        // Pass API timestamp if available
        const apiTimestamp = response.data.timestamp || response.data.issuedAt || response.data.createdAt;
        saveTokenInLocalStorage(response.data.token, rememberMe, apiTimestamp);
        saveUserDataLocalStorage(response.data.user);

        dispatch(loginConfirmedAction({
          token: response.data.token,
          user: response.data.user
        }));

        // Dispatch event to notify components of user login
        try {
          window.dispatchEvent(new Event('user-logged-in'));
        } catch (e) {
          console.error('Error dispatching user-logged-in event:', e);
        }

        console.log('Navigating to dashboard...');
        // Redirect logic
        const redirectPath = sessionStorage.getItem('redirectAfterLogin');
        if (redirectPath) {
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectPath, { replace: true });
        } else {
          getResolvedLandingPage().then((path) => {
            navigate(path, { replace: true });
          });
        }
      } catch (err) {
        notifyError('Error inside .then():', err);
      }
    } catch (error) {
      console.error('Microsoft login failed:', error);
      const errorMessage = formatError(
        error?.response?.data?.message || "Something went wrong during Microsoft login."
      );
      notifyError(errorMessage);
      dispatch(loginFailedAction(errorMessage));
    }
  };
}
export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
export const addRegistrationDetails = (formData) => {
  return {
    type: ADD_REGISTRATIONDETAILS,
    payload: formData
  };
};
